import { c as _c } from "react/compiler-runtime";
import { Tab, TabGroup, TabList } from '@headlessui/react';
import FunnelHeader from 'modules/funnels/funnel/components/funnel-header';
import FunnelStepsList from 'modules/funnels/funnel/components/funnel-steps-list';
import FunnelStepsListSkeleton from 'modules/funnels/funnel/components/funnel-steps-list-skeleton';
import { FunnelLoco } from 'modules/funnels/funnel/constants/funnel-loco';
import DeviceModeProvider from 'modules/funnels/funnel/context/device-mode-context';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import useContentScrollingSize from 'modules/funnels/funnel/hooks/use-content-scrolling-styles';
import { useFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-funnel-step-query';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelSettingsTabList } from 'modules/funnels/funnel/utils/get-funnel-settings-tab-list';
import { getFunnelStepSettingTabContent } from 'modules/funnels/funnel/utils/get-funnel-step-setting-tab-content';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { updateFunnelStepInDB } from 'shared/db/utils/funnels';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import useMediaQuery from 'shared/hooks/use-media-query';
import { twJoin } from 'tailwind-merge';
const Funnel: NextPage = () => {
  const $ = _c(85);
  const router = useRouter();
  const {
    t
  } = useLocoTranslation();
  const funnelId = parseInt(router.query.funnelId as string) as FunnelId;
  const {
    funnelStepsList,
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    updateFunnelStepQuery,
    clearFunnelStepTabQuery
  } = useUpdateFunnelStepQuery();
  const {
    isXS: isMobile
  } = useMediaQuery();
  const {
    contentRef,
    contentHeight,
    listHeight,
    listRef
  } = useContentScrollingSize(isMobile);
  const [selectedFunnelStep, setSelectedFunnelStep] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const settingsTabsList = getFunnelSettingsTabList(selectedFunnelStep?.type);
  const hasNoSelectedTemplate = !!selectedFunnelStep && !selectedFunnelStep.page;
  const isFunnelListIsEmpty = funnelStepsList && funnelStepsList.length === 0;
  let t0;
  if ($[0] !== hasNoSelectedTemplate || $[1] !== isFunnelListIsEmpty) {
    t0 = tabType => isFunnelListIsEmpty || hasNoSelectedTemplate && tabType !== FunnelStepSettingTabsEnum.stepConfiguration;
    $[0] = hasNoSelectedTemplate;
    $[1] = isFunnelListIsEmpty;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isTabDisabled = t0;
  let t1;
  if ($[3] !== funnelId || $[4] !== isMobile || $[5] !== updateFunnelStepQuery) {
    t1 = function selectFunnelStep(funnelStep) {
      setSelectedFunnelStep(funnelStep);
      updateFunnelStepQuery(funnelStep.id);
      if (!isMobile) {
        setSelectedTab(FunnelStepSettingTabsEnum.stepConfiguration);
        updateFunnelStepQuery(funnelStep.id, FunnelStepSettingTabsEnum.stepConfiguration);
      }
      updateFunnelStepInDB(funnelId, funnelStep.id);
    };
    $[3] = funnelId;
    $[4] = isMobile;
    $[5] = updateFunnelStepQuery;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const selectFunnelStep = t1;
  let t2;
  if ($[7] !== isTabDisabled || $[8] !== updateFunnelStepQuery) {
    t2 = function selectFunnelStepTab(tabType_0, funnelStep_0) {
      if (!funnelStep_0 || isTabDisabled(tabType_0)) {
        return;
      }
      setSelectedTab(tabType_0);
      updateFunnelStepQuery(funnelStep_0.id, tabType_0);
    };
    $[7] = isTabDisabled;
    $[8] = updateFunnelStepQuery;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const selectFunnelStepTab = t2;
  const displayedTab = hasNoSelectedTemplate ? FunnelStepSettingTabsEnum.stepConfiguration : selectedTab;
  let t3;
  if ($[10] !== clearFunnelStepTabQuery) {
    t3 = () => {
      clearFunnelStepTabQuery();
      setSelectedTab(null);
    };
    $[10] = clearFunnelStepTabQuery;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const resetSelectedMobileTab = t3;
  let t4;
  if ($[12] !== funnelStepsList) {
    t4 = {
      funnelStepsList,
      setSelectedFunnelStep
    };
    $[12] = funnelStepsList;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const {
    selectedFunnelStepId,
    selectedFunnelStepTab
  } = useFunnelStepQuery(t4);
  let t5;
  if ($[14] !== funnelId || $[15] !== funnelStepsList || $[16] !== isMobile || $[17] !== selectedFunnelStep?.id || $[18] !== selectedFunnelStepId || $[19] !== selectedFunnelStepTab) {
    t5 = () => {
      if (funnelStepsList && Number(selectedFunnelStepId) !== selectedFunnelStep?.id) {
        const selectedFunnelStepEntity = funnelStepsList.find(funnelStep_1 => funnelStep_1.id === Number(selectedFunnelStepId));
        if (selectedFunnelStepEntity && selectedFunnelStepId) {
          setSelectedFunnelStep(selectedFunnelStepEntity);
          updateFunnelStepInDB(funnelId, selectedFunnelStepId);
          if (selectedFunnelStepTab) {
            setSelectedTab(selectedFunnelStepTab);
          } else {
            if (isMobile) {
              setSelectedTab(null);
            } else {
              setSelectedTab(FunnelStepSettingTabsEnum.stepConfiguration);
            }
          }
        }
      }
    };
    $[14] = funnelId;
    $[15] = funnelStepsList;
    $[16] = isMobile;
    $[17] = selectedFunnelStep?.id;
    $[18] = selectedFunnelStepId;
    $[19] = selectedFunnelStepTab;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== funnelStepsList || $[22] !== isMobile || $[23] !== selectedFunnelStepId) {
    t6 = [selectedFunnelStepId, funnelStepsList, isMobile];
    $[21] = funnelStepsList;
    $[22] = isMobile;
    $[23] = selectedFunnelStepId;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[25] !== isMobile || $[26] !== selectedTab) {
    t7 = () => {
      if (!isMobile && !selectedTab) {
        setSelectedTab(FunnelStepSettingTabsEnum.stepConfiguration);
      }
    };
    t8 = [isMobile, selectedTab];
    $[25] = isMobile;
    $[26] = selectedTab;
    $[27] = t7;
    $[28] = t8;
  } else {
    t7 = $[27];
    t8 = $[28];
  }
  useEffect(t7, t8);
  let t9;
  if ($[29] !== updateFunnelStepQuery) {
    t9 = () => {
      if (window.location.hash) {
        const stepId = window.location.hash.replace("#step", "");
        updateFunnelStepQuery(Number(stepId));
      }
    };
    $[29] = updateFunnelStepQuery;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== router) {
    t10 = [router];
    $[31] = router;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  useEffect(t9, t10);
  const T0 = DeviceModeProvider;
  const t11 = "flex flex-col gap-5";
  let t12;
  if ($[33] !== funnelId || $[34] !== selectedFunnelStep) {
    t12 = <FunnelHeader funnelId={funnelId} selectedFunnelStep={selectedFunnelStep} />;
    $[33] = funnelId;
    $[34] = selectedFunnelStep;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const t13 = "flex flex-col gap-3 lg:flex-row lg:gap-6";
  const t14 = `relative w-full lg:min-h-fit lg:w-[330px] ${isMobile && selectedTab && !isFunnelListIsEmpty ? "hidden" : ""}`;
  let t15;
  if ($[36] !== funnelId || $[37] !== funnelStepsList || $[38] !== listHeight || $[39] !== listRef || $[40] !== mutateFunnelStepsList || $[41] !== selectFunnelStep || $[42] !== selectedFunnelStep) {
    t15 = !funnelStepsList ? <FunnelStepsListSkeleton /> : <FunnelStepsList funnelId={funnelId} funnelSteps={funnelStepsList} mutate={mutateFunnelStepsList} selectedFunnelStep={selectedFunnelStep} selectFunnelStep={selectFunnelStep} listHeight={listHeight} listRef={listRef} />;
    $[36] = funnelId;
    $[37] = funnelStepsList;
    $[38] = listHeight;
    $[39] = listRef;
    $[40] = mutateFunnelStepsList;
    $[41] = selectFunnelStep;
    $[42] = selectedFunnelStep;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t14 || $[45] !== t15) {
    t16 = <div className={t14}>{t15}</div>;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  const t17 = "bg-background-secondary customScroll flex h-full min-h-[200px] w-full flex-col items-stretch gap-5 overflow-x-hidden rounded-md";
  let t18;
  if ($[47] !== contentHeight) {
    t18 = contentHeight ? {
      height: contentHeight,
      overflowY: "scroll"
    } : {};
    $[47] = contentHeight;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  const t19 = "flex flex-col gap-7 lg:gap-10";
  const T1 = TabGroup;
  const T2 = TabList;
  const t20 = `funnelCustomScroll flex flex-col gap-y-0 overflow-x-auto lg:flex-row ${isMobile && selectedTab ? "hidden" : ""}`;
  let t21;
  if ($[49] !== displayedTab || $[50] !== isTabDisabled || $[51] !== selectFunnelStepTab || $[52] !== selectedFunnelStep || $[53] !== t) {
    t21 = tab => {
      const disabled = isTabDisabled(tab.type);
      const isSelected = tab.type === displayedTab;
      return <Tab onClick={() => selectFunnelStepTab(tab.type, selectedFunnelStep)} key={tab.type} disabled={disabled} className={twJoin(isSelected ? "lg:text-text-primary lg:border-b-brand-primary lg:border-b-[3px]" : "lg:border-b-text-primary/15 lg:border-b-1", "border-[rgb(var(--text-primary))]/15 w-full border-b-[1px] px-4 py-4 outline-hidden last:border-b-[0px] lg:w-fit lg:pb-[22px] lg:pt-[27px] lg:first:pl-8 lg:last:border-b-[1px]", !disabled && "lg:main-transition-colors", disabled && "cursor-not-allowed pointer-events-none text-text-tertiary/50 opacity-50")}><div className="flex gap-2">{tab.iconRenderer(isSelected && !disabled)}<span className="font-inter whitespace-nowrap font-semibold sm:text-[15px]">{t(tab.caption)}</span></div></Tab>;
    };
    $[49] = displayedTab;
    $[50] = isTabDisabled;
    $[51] = selectFunnelStepTab;
    $[52] = selectedFunnelStep;
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  const t22 = settingsTabsList.map(t21);
  let t23;
  if ($[55] !== T2 || $[56] !== t20 || $[57] !== t22) {
    t23 = <T2 className={t20}>{t22}</T2>;
    $[55] = T2;
    $[56] = t20;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== T1 || $[60] !== t23) {
    t24 = <T1>{t23}</T1>;
    $[59] = T1;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== displayedTab || $[63] !== funnelId || $[64] !== isFunnelListIsEmpty || $[65] !== selectedFunnelStep) {
    t25 = getFunnelStepSettingTabContent(funnelId, selectedFunnelStep, displayedTab, isFunnelListIsEmpty);
    $[62] = displayedTab;
    $[63] = funnelId;
    $[64] = isFunnelListIsEmpty;
    $[65] = selectedFunnelStep;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== contentRef || $[68] !== t24 || $[69] !== t25) {
    t26 = <div className={t19} ref={contentRef}>{t24}{t25}</div>;
    $[67] = contentRef;
    $[68] = t24;
    $[69] = t25;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t18 || $[72] !== t26) {
    t27 = <div className={t17} style={t18}>{t26}</div>;
    $[71] = t18;
    $[72] = t26;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  let t28;
  if ($[74] !== t16 || $[75] !== t27) {
    t28 = <div className={t13}>{t16}{t27}</div>;
    $[74] = t16;
    $[75] = t27;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  let t29;
  if ($[77] !== t12 || $[78] !== t28) {
    t29 = <div className={t11}>{t12}{t28}</div>;
    $[77] = t12;
    $[78] = t28;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[80] !== T0 || $[81] !== isMobile || $[82] !== resetSelectedMobileTab || $[83] !== t29) {
    t30 = <T0 resetSelectedMobileTab={resetSelectedMobileTab} isMobile={isMobile}>{t29}</T0>;
    $[80] = T0;
    $[81] = isMobile;
    $[82] = resetSelectedMobileTab;
    $[83] = t29;
    $[84] = t30;
  } else {
    t30 = $[84];
  }
  return t30;
};
export const getServerSideProps = getBaseServerSideProps(FunnelLoco, 'header.top_menu.funnels');
export default Funnel;